// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@tailwind components;@tailwind utilities;@tailwind variants;.hide-scrollbar::-webkit-scrollbar{display:none}.hide-scrollbar{-ms-overflow-style:none;scrollbar-width:none}.choices__inner{padding-bottom:4px !important}.text-mc-gray{color:#525f73}.bg-mc-gray{background-color:#525f73}.bg-blue{background-color:#2b6cb0}", ""]);
// Exports
module.exports = exports;
